export default __webpack_public_path__ + "static/media/Fraktionlogo_white.cedcafd6.webp";